// extracted by mini-css-extract-plugin
export var button = "_ri-1";
export var container = "_ri-0";